// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"928":"d776bfb0","2424":"e841aef0","2751":"b82c45cb","3458":"42f154e5","4390":"d12eac8b","6294":"09ba6c06","8097":"7edcb3b0","8562":"b767290f","9712":"91652f37"}[chunkId] + ".chunk.js";
};